import ErrorBoundary from 'shared/components/ErrorBoundary';
import PropTypes from 'prop-types';
import React from 'react';
import StarRating from 'react-star-rating-component';
import { withTheme } from '@material-ui/core/styles';
import styles from './styles.css';
/**
 * Handle display of a rating for a product
 * @param {React props} productReviewRating
 */

// This is the default color that the react star rating component uses.
// However, when rendering half stars, the color of the remaining empty stars must be specified or else it defaults to black
export const defaultStarColor = '#ffb400';

const Rating = ({ productReviewRating, theme }) => {
	const starEmptyColor = productReviewRating === 0 ? theme.palette.grey[900] : defaultStarColor;
	return (
		<ErrorBoundary>
			<StarRating
				className={styles['star-rating']}
				name="reviewStar"
				editing={false}
				emptyStarColor={starEmptyColor}
				value={productReviewRating}
				renderStarIcon={
					productReviewRating > 0
						? (index, value) => <span className={index <= value ? 'fas fa-star' : 'far fa-star'} />
						: () => <span className="far fa-star" />
				}
				renderStarIconHalf={() => (
					<span>
						<span style={{ position: 'absolute' }}>
							<i className="far fa-star" />
						</span>
						<span>
							<i className="fas fa-star-half-alt" />
						</span>
					</span>
				)}
			/>
		</ErrorBoundary>
	);
};

Rating.propTypes = {
	productReviewRating: PropTypes.number,
	theme: PropTypes.instanceOf(Object).isRequired,
};

Rating.defaultProps = {
	productReviewRating: 0,
};

export default withTheme(Rating);
